import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      {props.imgPath && (
        <div className="project-card-media">
          <Card.Img variant="top" src={props.imgPath} alt={`${props.title} preview`} />
        </div>
      )}
      <Card.Body>
        <strong className="purple">
          <Card.Title>{props.title}</Card.Title>
        </strong>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {(props.ghLink || props.demoLink) && (
          <div className="project-card-actions">
            {props.ghLink && (
              <Button variant="primary" href={props.ghLink} target="_blank">
                <BsGithub /> &nbsp;
                {props.isBlog ? "Blog" : "GitHub"}
              </Button>
            )}

            {!props.isBlog && props.demoLink && (
              <Button variant="primary" href={props.demoLink} target="_blank">
                <CgWebsite /> &nbsp;
                Demo
              </Button>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
